// Function loadHotspotBlock loads the HotspotBlock class by dynamically importing the js on demand if needed

export function loadHotspotBlock($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-hotspot-block-chunk" */ '../widgets/hotspotBlock').then(wg => {

		const { HotspotBlock } = wg;

		let $wg = $parentEl.querySelector('[data-wg="HotspotBlock"]');

		if(!$wg) {
			// console.info('HotspotBlock: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="HotspotBlock"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new HotspotBlock($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new HotspotBlock($wg);
		}


	}).catch(error => error+'An error occurred while loading the HotspotBlock widget');

}
